import {restoreMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialFunctionKeys, materialFunctionMutationKeys} from "../../../materialFunction-keys";

export function restoreMaterialFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (materialFunctionId: string) => restoreMaterialFunction(materialFunctionId),
    mutationKey: materialFunctionMutationKeys.restoreMaterialFunction,
    onSuccess: async (_data, materialFunctionId, _context, {client}) => {
      client.removeQueries({queryKey: materialFunctionKeys.detail(materialFunctionId)});
      await client.invalidateQueries({queryKey: materialFunctionKeys.lists()});
    },
  });
}
